import { generateId } from '@freelancer/datastore/testing';
import {
  GeneratePoolOptions,
  freelancerPool,
  deloittePool,
  arrowPool,
  facebookPool,
  talentNetworkPool,
  anotherTalentNetworkPool,
} from '../pools';
import { AdminPoolModel } from './admin-pools.model';

export interface GenerateAdminPoolOptions extends GeneratePoolOptions {
  readonly membersCount?: number;
}

export function generateAdminPoolObject({
  name,
  displayName,
  isTalentNetwork = false,
  isTestPool = false,
  dateCreated = Date.now(),
  membersCount = 0,
  isInsourceEnabled = false,
  isCurrencyEnabled = true,
}: GenerateAdminPoolOptions): AdminPoolModel {
  return {
    id: generateId(),
    name,
    displayName,
    isTalentNetwork,
    isTestPool,
    dateCreated,
    membersCount,
    isInsourceEnabled,
    isCurrencyEnabled,
  };
}

export function generateAdminPoolObjects(
  pools: readonly AdminPoolModel[],
): readonly AdminPoolModel[] {
  return pools;
}

export function freelancerAdminPool(): AdminPoolModel {
  return {
    ...freelancerPool(),
    membersCount: 100,
  };
}

export function deloitteAdminPool(): AdminPoolModel {
  return {
    ...deloittePool(),
    membersCount: 100,
  };
}

export function arrowAdminPool(): AdminPoolModel {
  return {
    ...arrowPool(),
    membersCount: 20,
  };
}

export function facebookAdminPool(): AdminPoolModel {
  return {
    ...facebookPool(),
    membersCount: 50,
  };
}

export function talentNetworkAdminPool(): AdminPoolModel {
  return {
    ...talentNetworkPool(),
    membersCount: 100,
  };
}

export function anotherTalentNetworkAdminPool(): AdminPoolModel {
  return {
    ...anotherTalentNetworkPool(),
    membersCount: 10,
  };
}
